import { BarChartViewModel, ChartBar, ChartItem } from "./bar-chart-view-model";
import { MepService } from "../../../../../services/mep/mep.service";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { MepGetDashboardVesselTypeDistributionRequest, MepDashboardVesselTypeDistributionResponseItem } from "../../../../../models/mep/mep.models";
import * as Enumerable from "linq";
import { MepVesselTypeColors } from "../../../../../constants/mep/mep.constants";
import { VesselStatisticsType } from "../tabs/mep-dashboard/partials/mep-vessel-statistics/mep-vessel-statistics";

export class MepDashboardVesselDistributionViewModel {
    chartViewModel: BarChartViewModel;
    loadingVesselTypeDistribution: boolean = false;

    constructor(private mepService: MepService, private notificationClientService: NotificationClientService, private vesselStatisticType: number) {
    }

    loadVesselTypeDistribution(request: MepGetDashboardVesselTypeDistributionRequest) {
        this.loadingVesselTypeDistribution = true;
        this.mepService.getMepDashboardVesselTypeDistribution(request).then(response => {
            const vesselDistributionItems = Enumerable.from(response.result).toArray();

            this.initBarChartForVesselCalls(vesselDistributionItems);
            this.loadingVesselTypeDistribution = false;
        }).catch(() => {
            this.notificationClientService.show("MEP Vessel Type Distribution", "Error retrieving the vessel type distribution!", NotificationType.Error);
            this.loadingVesselTypeDistribution = false;
        });
    }

    initBarChartForVesselCalls(vesselDistributionItems: MepDashboardVesselTypeDistributionResponseItem[]) {
        let maxValue = 0;
        const chartItems: ChartItem[] = [];
        const vesselTypes = Enumerable.from(vesselDistributionItems)
            .orderByDescending(x => x.count)
            .select(x => {
                return {
                    id: x.vesselTypeId,
                    name: x.vesselTypeName
                }
            })
            .distinct(x => x.id)
        const groupedData = Enumerable.from(vesselDistributionItems)
            .groupBy(x => x.vesselTypeId)
            .select(x => {
                return x.sum(a => a.count);
            })
            .toArray();
        maxValue = Enumerable.from(groupedData).max();

        vesselTypes.forEach(vesselType => {
            const bars : ChartBar[] = Enumerable.from(vesselDistributionItems)
                .where(x => x.vesselTypeId == vesselType.id)
                .select(x => {
                    return {
                        id: x.vesselTypeId,
                        barName: x.vesselTypeName,
                        value: x.count,
                        size: x.count
                    }
                })
                .orderByDescending(x => x.value)
                .toArray();

            const chartItem : ChartItem = {
                id: vesselType.id,
                itemName: vesselType.name,
                bars: bars
            }
            chartItems.push(chartItem);
        });

        this.chartViewModel = new BarChartViewModel(chartItems, maxValue, 6);
        if (this.vesselStatisticType == VesselStatisticsType.TugboatJobs) {
            const tugboatTypeId = 8;
            const tugboatJobsColor = MepVesselTypeColors.filter(x => x.id == tugboatTypeId)[0];
            this.chartViewModel.chartLegend.generateLegendItems(vesselTypes.toArray());
            this.chartViewModel.chartLegend.legendItems.forEach(item => {
                item.color = tugboatJobsColor ? tugboatJobsColor.color : item.color;
            });
        }
        else {
            this.chartViewModel.chartLegend.legendItems = MepVesselTypeColors.filter(x => vesselTypes.where(y => y.id == x.id).any());
        }
    }

}
